import React from "react";
import { TnSkeleton } from "./TnSkeleton";
import { clickableProps } from "./clickable";

/*
One KPI figure. Used by both the Performance row and the case-snapshot row.

`value` may legitimately be 0, so it is only treated as missing when it is
null/undefined - never falsy-checked.

`onClick` makes the tile a click-to-filter control for the case list; `active`
marks the one currently applied.
*/
const KpiTile = function (props) {
  const { label, value, hint, delta, deltaTone, loading, suffix, onClick, active } =
    props;

  const hasValue = value !== null && value !== undefined;
  const className =
    "tn-kpi" +
    (onClick ? " tn-clickable" : "") +
    (onClick && active ? " tn-clickable-active" : "");

  return (
    <div className={className} {...clickableProps(onClick, active)}>
      <div className="tn-kpi-label">{label}</div>
      <div className="tn-kpi-main">
        {loading ? (
          <TnSkeleton w="72px" h="30px" />
        ) : (
          <div className="tn-kpi-value">
            {hasValue ? value : "—"}
            {hasValue && suffix ? (
              <span className="tn-kpi-suffix">{suffix}</span>
            ) : null}
          </div>
        )}
        {delta ? (
          <div className={"tn-kpi-delta tn-delta-" + (deltaTone || "neutral")}>
            {delta}
          </div>
        ) : null}
      </div>
      {hint ? <div className="tn-kpi-hint">{hint}</div> : null}
    </div>
  );
};

export default KpiTile;
